// Nuotraukų saugykla (IndexedDB). Nuotraukos per didelės localStorage'ui.
//
// v1 store 'nuotraukos'   — raktas = vietos id (viena nuotrauka vietai, senoji logika).
// v2 store 'prisiminimai' — raktas = prisiminimo id (kelios nuotraukos, geo-žymėtos).

const DB = 'kelioniu'
const STORE = 'nuotraukos'
const STORE_PR = 'prisiminimai'

function atverti() {
  return new Promise((res, rej) => {
    if (!('indexedDB' in window)) { rej(new Error('nėra indexedDB')); return }
    const r = indexedDB.open(DB, 2)
    r.onupgradeneeded = () => {
      const db = r.result
      if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE)
      if (!db.objectStoreNames.contains(STORE_PR)) db.createObjectStore(STORE_PR)
    }
    r.onsuccess = () => res(r.result)
    r.onerror = () => rej(r.error)
  })
}

function putRaktu(store, raktas, dataUrl) {
  return atverti().then(db => new Promise((res, rej) => {
    const tx = db.transaction(store, 'readwrite')
    tx.objectStore(store).put(dataUrl, raktas)
    tx.oncomplete = () => res(true)
    tx.onerror = () => rej(tx.error)
  })).catch(() => false)
}

function getRaktu(store, raktas) {
  return atverti().then(db => new Promise((res) => {
    const tx = db.transaction(store, 'readonly')
    const rq = tx.objectStore(store).get(raktas)
    rq.onsuccess = () => res(rq.result || null)
    rq.onerror = () => res(null)
  })).catch(() => null)
}

// ── Senoji logika (vieta id → viena nuotrauka) ──
export async function issaugotiNuotrauka(id, dataUrl) { return putRaktu(STORE, id, dataUrl) }
export async function gautiNuotrauka(id) {
  // Pirma bandom senąjį store, tada — pirmą prisiminimą (jei perkelta į naują modelį)
  const sena = await getRaktu(STORE, id)
  return sena
}

// ── Prisiminimų nuotraukos (prisiminimo id → nuotrauka) ──
export async function issaugotiPrisiminimoNuotrauka(prId, dataUrl) { return putRaktu(STORE_PR, prId, dataUrl) }
export async function gautiPrisiminimoNuotrauka(prId) { return getRaktu(STORE_PR, prId) }

export async function istrintiPrisiminimoNuotrauka(prId) {
  return atverti().then(db => new Promise((res) => {
    const tx = db.transaction(STORE_PR, 'readwrite')
    tx.objectStore(STORE_PR).delete(prId)
    tx.oncomplete = () => res(true)
    tx.onerror = () => res(false)
  })).catch(() => false)
}

// Sumažina ir suspaudžia nuotrauką (max ~1000px, JPEG) — kad tilptų saugykloje.
export function suspaustiNuotrauka(file, maxDydis = 1000) {
  return new Promise((res, rej) => {
    const reader = new FileReader()
    reader.onload = () => {
      const img = new Image()
      img.onload = () => {
        let { width, height } = img
        if (width > height && width > maxDydis) { height = Math.round(height * maxDydis / width); width = maxDydis }
        else if (height > maxDydis) { width = Math.round(width * maxDydis / height); height = maxDydis }
        const canvas = document.createElement('canvas')
        canvas.width = width
        canvas.height = height
        canvas.getContext('2d').drawImage(img, 0, 0, width, height)
        res(canvas.toDataURL('image/jpeg', 0.72))
      }
      img.onerror = rej
      img.src = reader.result
    }
    reader.onerror = rej
    reader.readAsDataURL(file)
  })
}
